import { attempt, isError } from 'lodash';

/**
 * Trả ra giá trị mặc định nếu param1 (0, null, undefined, false hoặc "")
 *
 * @category all types
 * @param any
 * @param any
 * @returns Returns default value any.
 * @example
 *
 */
function dv(val: any, dVal: any = null) {
  return val || dVal;
}

/**
 * same JSON parse
 */
function jsonParse(str: string, defaultValue = {}) {
  const result = attempt(JSON.parse.bind(null, str));
  if (isError(result) || typeof result != 'object') {
    return defaultValue;
  }

  return result;
}

// vanillaJS
function isJSON(str: string) {
  try {
    return JSON.parse(str) && !!str;
  } catch (e) {
    return false;
  }
}

function getLS(keyName: string, isParse: boolean = false): string {
  if (!window.localStorage) return '';

  const localResult = window.localStorage.getItem(keyName) || '';

  if (isParse && localResult) {
    return jsonParse(localResult);
  }

  return localResult;
}

function setLS(keyName: string, data: any | number | string) {
  if (!window.localStorage) return;

  if (typeof data === 'string' || typeof data === 'number') {
    window.localStorage.setItem(keyName, `${data}`);
    return;
  }

  window.localStorage.setItem(keyName, JSON.stringify(data));
}

export { dv, jsonParse, isJSON, getLS, setLS };
